import { render } from "./deals-modal.vue?vue&type=template&id=0ff5d4ac"
import script from "./deals-modal.vue?vue&type=script&lang=js"
export * from "./deals-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__